import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@finora/ui";
import { api } from "../../lib/api";

/** Dugme za restart API servisa (pm2 reload, bez prekida rada) - samo Super Admin. */
export function RestartServiceSection() {
  const [done, setDone] = useState(false);
  const restart = useMutation({
    mutationFn: () => api.restartApiService(),
    onSuccess: () => {
      setDone(true);
      setTimeout(() => setDone(false), 15000);
    },
  });

  return (
    <div className="mt-8 rounded-lg border border-slate-200 bg-white p-4">
      <h2 className="mb-1 text-base font-semibold text-slate-900">Restart servisa</h2>
      <p className="mb-3 text-sm text-slate-500">
        Ponovo pokreće HAFiskal API (posle nove verzije). Radnici se menjaju jedan po jedan, pa aplikacija ostaje
        dostupna; traje oko pola minuta.
      </p>
      <Button
        variant="secondary"
        disabled={restart.isPending}
        onClick={() => {
          if (window.confirm("Restartovati HAFiskal API servis?")) restart.mutate();
        }}
      >
        <RefreshCw className="mr-2 h-4 w-4" />
        {restart.isPending ? "Šaljem…" : "Restartuj servis"}
      </Button>
      {done && <p className="mt-2 text-sm text-emerald-600">Restart je pokrenut. Sačekaj pola minuta pa osveži stranicu.</p>}
      {restart.isError && <p className="mt-2 text-sm text-red-600">Restart nije uspeo.</p>}
    </div>
  );
}
